export const VACANCY_CONSTS = {
    GET_VACANCIES: "GET_VACANCIES",
    CREATE_VACANCY: "CREATE_VACANCY",
    UPDATE_VACANCIES_POSITIONS: "UPDATE_VACANCIES_POSITIONS",
    GET_VACANCIES_BY_ID: "GET_VACANCIES_BY_ID",
    UPDATE_VACANCY_BY_ID: "UPDATE_VACANCY_BY_ID",
    DELETE_VACANCY_BY_ID: "DELETE_VACANCY_BY_ID",
};
